/**
 * Номер з відповіді GET …/records/{rt}/next-code: `{ "code": n }` (також `{ "nextCode": n }` або саме число); не додатне ціле — null.
 * Чиста функція.
 */
export function nextCodeOf(body: unknown): number | null {
  const fields = body && typeof body === 'object' ? (body as Record<string, unknown>) : null;
  const value = typeof body === 'number' ? body : fields ? (fields['code'] ?? fields['nextCode']) : null;
  const code = Number(value ?? NaN);
  return Number.isInteger(code) && code > 0 ? code : null;
}
